export const READY = 'ready'
export const SHOWING = 'showing'
export const DONE = 'done'
